module.exports = __webpack_public_path__ + "img/jason-goodman-Oalh2MojUuk-unsplash.a3c05362.jpg";